<div class="ps-modal" tabindex="-1" role="dialog" #modal>
  <div class="modal-content">
    <div class="modal-header">
      <ng-content select="ps-ui-modal-title, [psUiModalTitle]"></ng-content>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="close()"
        *ngIf="showButtonClose"
      ></button>
    </div>
    <ng-content select="ps-ui-modal-body, [psUiModalBody]"></ng-content>
    <ng-content select="ps-ui-modal-footer, [psUiModalFooter]"></ng-content>
  </div>
</div>
